<app-loader *ngIf="isDisabled"></app-loader>
<form name="VehicleForm" (ngSubmit)="Validate(VehicleForm)" #VehicleForm="ngForm">
    <div class="card">
        <div class="card-header">
            <label>Vehicle</label>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <label>Vehicle Name</label>
                    <input type="text" [maxLength]="100" class="form-control" name="VehicleName"
                        placeholder="Ex. Train" [(ngModel)]="Vehicle.VehicleName"
                        #VehicleName="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter vehicle name !
                    </div>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-12">
                    <label>Class Name</label>
                    <input type="text" [maxLength]="100" class="form-control" name="ClassName" placeholder="Ex. 3rd Ac"
                        [(ngModel)]="Vehicle.ClassName" #ClassName="ngModel">
                    <span class="rightHint">Multiple Class name in comma separated (eg. 3rd Ac,2nd Ac)</span>
                    <div class="invalid-feedback">
                        Please enter class name !
                    </div>
                </div>
            </div> -->
            <div class="row py-1">
                <div class="col-md-6">
                    <label class="Label">
                        Local :
                        <input type="checkbox" name="IsLocal" [(ngModel)]="Vehicle.IsLocal" ngbCheckbox />
                    </label>
                </div>
                <div class="col-md-6">
                    <label class="Label">
                        Out Station :
                        <input type="checkbox" name="IsOutStation" [(ngModel)]="Vehicle.IsOutStation" ngbCheckbox />
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer m-2">
        <div class="row">
            <div class="col">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="Vehicle.IsActive"
                        [name]="'Active'" id="flexCheckDefault">
                    <label class="form-check-label" for="flexCheckDefault">
                        Active
                    </label>
                </div>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary me-1" (click)="close()" [disabled]="isDisabled"
                    ngbTooltip="Cancel" container="body" placement="top">
                    Cancel
                    <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                </button>

                <button type="submit" class="btn btn-primary" [disabled]="isDisabled"
                    *ngIf="((this.Vehicle.ESS_VehicleMasterId == 0 && this.common.PageRight.IsAdd) || (this.Vehicle.ESS_VehicleMasterId > 0 && this.common.PageRight.IsEdit))"><i
                        class="bi bi-save2" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </div>
</form>